import { PropTypes } from 'prop-types'
import Button from 'components/formElements/Button'
import DefaultSelect from 'components/formElements/DefaultSelect'
import { useParams } from 'react-router-dom'
import React, { useEffect, useState } from 'react'
import { useRequest } from 'hooks/useRequest'
import useToast from 'hooks/useToast'
import { Calendar } from 'primereact/calendar'
import moment from 'moment'
import { useFileReader } from 'hooks/useFileReader'
import Icons from 'assets/icons'
import { InputNumber } from 'primereact/inputnumber'
import { currencyTypes } from 'utils/Constants'

const AddLeasingModalContent = ({ handleClose, handleAdd, leasingId }) => {
    const { projectId } = useParams()
    const [request, loading] = useRequest()
    const { showToast } = useToast()
    const [addForm, setAddForm] = useState({
        projectId: projectId,
        startDate: null,
        endDate: null,
        licenseNote: null,
        currency: null,
        monthlyAmount: null,
        documents: []
    })
    const [fileData, setFileData, convert] = useFileReader()

    useEffect(() => {
        getLeasing()
    }, [leasingId])

    const getLeasing = () => {
        let id = addForm.id || leasingId
        if (!id) return

        request(`/Leasing/GetLeasingById`, { params: { id: id } }).then((res) => {
            if (res.data.ok) {
                setAddForm(res.data.result)
            }
        })
    }

    const handleChange = (e, name) => {
        if (name) {
            setAddForm((prev) => ({ ...prev, [name]: e }))
        } else {
            setAddForm((prev) => ({ ...prev, [e.target.name]: e.target.value }))
        }
    }

    const handleSubmit = () => {
        if (!addForm.currency) {
            showToast('Lütfen para birimi seçin', 'error')
        } else if (!(addForm.monthlyAmount > 0)) {
            showToast('Lütfen aylık tutarı girin', 'error')
        } else if (!addForm.startDate) {
            showToast('Lütfen başlangıç dönemini girin', 'error')
        } else if (!addForm.endDate) {
            showToast('Lütfen bitiş dönemini girin', 'error')
        } else {
            const formData = new FormData()
            for (let key in addForm) {
                let value = addForm[key]
                if (value === null || value === undefined || key === "documents") continue
                formData.append(key.charAt(0).toUpperCase() + key.slice(1), value)
            }
            fileData.forEach(v => {
                formData.append(`Files`, v.file)
            })

            request('/Leasing/UpsertLeasing', {
                method: 'PUT',
                data: formData
            }).then((res) => {
                if (res.data.ok) {
                    if (leasingId) {
                        showToast('Kiralama güncellendi', 'success')
                    } else {
                        showToast('Kiralama eklendi', 'success')
                    }
                    handleClose()
                    handleAdd()
                }
            })
        }
    }

    const handleFiles = (files) => {
        convert(files)
    }

    const removeFile = (file) => {
        setFileData((prev) => [...prev.filter((f) => f.fileName !== file.fileName)])
    }

    const removeDocument = (document) => {
        request('/Leasing/DeleteLeasingDocument', {
            method: 'DELETE',
            data: { id: document.id }
        }).then((res) => {
            if (res.data.ok) {
                addForm.documents = addForm.documents.filter((f) => f.id !== document.id)
                showToast('Doküman silindi', 'success')
            }
        })
    }

    return (
        <>
            <div className='w-100 d-flex flex-column gap-3 approval-modal-content'>
                <div className='row'>
                    <div className='col-md-6'>
                        <div className='form-control'>
                            <label className='text-bold'>Başlangıç Dönemi</label>
                            <Calendar
                                 dateFormat='dd/mm/yy'
                                placeholder='Başlangıç Dönemi'
                                name='startDate'
                                value={addForm.startDate && moment(addForm.startDate).locale('en')._d}
                                onChange={(e) => {
                                    handleChange(moment(e.target.value).add(3, 'hours').toISOString(), e.target.name)
                                }}
                            />
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className='form-control'>
                            <label className='text-bold'>Bitiş Dönemi</label>
                            <Calendar
                                dateFormat='dd/mm/yy'
                                placeholder='Bitiş Dönemi'
                                name='endDate'
                                value={addForm.endDate && moment(addForm.endDate).locale('en')._d}
                                onChange={(e) => {
                                    handleChange(moment(e.target.value).add(3, 'hours').toISOString(), e.target.name)
                                }}
                            />
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-md-6'>
                        <div className='form-control'>
                            <InputNumber
                                mode='decimal'
                                value={addForm.monthlyAmount}
                                minFractionDigits={2}
                                maxFractionDigits={2}
                                placeholder='Aylık Tutar'
                                onChange={(e) => handleChange(e.value, 'monthlyAmount')}
                                inputProps={{ 
                                    autoComplete: 'off',
                                    'data-lpignore': 'true',
                                    'data-form-type': 'other',
                                    name: `monthlyAmount_${Math.random()}`
                                }}
                            />
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className='form-control'>
                            <DefaultSelect
                                placeholder='Para Birimi'
                                value={currencyTypes.find(c => c.value === addForm.currency)}
                                name='currency'
                                selectOptions={currencyTypes}
                                handleChange={(e) => handleChange(e.value, "currency")}
                            />
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-md-12'>
                        <div className='form-control'>
                            <label className='text-bold'>Lisans Notu</label>
                            <input
                                placeholder='Lisans Notu'
                                className='default-input'
                                type='text'
                                name='licenseNote'
                                value={addForm.licenseNote}
                                onChange={(e) => handleChange(e)}
                            />
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-md-12'>
                        <label className='filterTask-file-upload--form--row--item--file-uploader--label' htmlFor='file-uploader'>
                            <span className='filterTask-file-upload--form--row--item--file-uploader--label--text'>Sözleşme yüklemek için tıklayınız</span>
                        </label>
                        <input
                            type='file'
                            name='file'
                            multiple
                            onClick={(e) => e.target.value = null}
                            onChange={(e) => handleFiles(e.target.files)}
                            id='file-uploader'
                            className='filterTask-file-upload--form--row--item--file-uploader--input'
                        />
                        {fileData?.length > 0 &&
                            <div className='ml-4 w-100 mt-2 gap-3'>
                                {fileData?.map((file, i) => (
                                    <div className='text-sm comment-fileList w-unset' key={i}>
                                        <div className='d-flex align-items-center'>{file?.fileName}</div>
                                        <Icons.delete onClick={() => {removeFile(file)}} size={16} />
                                    </div>
                                ))}
                            </div>
                        }
                        {addForm.documents?.length > 0 &&
                            <div className='ml-4 w-100 mt-2 gap-3'>
                                {addForm.documents?.map((document, i) => (
                                    <div className='text-sm comment-fileList w-unset' key={i}>
                                        <div className='d-flex align-items-center'>{document.fileName}</div>
                                        <Icons.delete onClick={() => {removeDocument(document)}} size={16} />
                                    </div>
                                ))}
                            </div>
                        }
                    </div>
                </div>
                <div className='row justify-content-center'>
                    <div className='col-md-3'>
                        <Button
                            handleClick={handleSubmit}
                            className='btn-success w-100 justify-content-center'
                            title={'Kaydet'}
                            disabled={loading}
                        />
                    </div>
                    <div className='col-md-3'>
                        <Button
                            handleClick={handleClose}
                            className='btn-danger-outline w-100 justify-content-center'
                            title={'Vazgeç'}
                            disabled={loading}
                        />
                    </div>
                </div>
            </div>
        </>
    )
}

AddLeasingModalContent.propTypes = {
    handleClose: PropTypes.func,
    handleAdd: PropTypes.func,
    leasingId: PropTypes.number
}

export default AddLeasingModalContent
